module.exports = __webpack_public_path__ + "img/person_chenhaitao.65c9f61e.jpg";